module.exports = __webpack_public_path__ + "img/4-4.f5c085a9.svg";